var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDayfooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 202,
    width: 802,
    y: -1,
    x: -1
  }), /*#__PURE__*/React.createElement("g", {
    display: "none",
    overflow: "visible",
    y: 0,
    x: 0,
    height: "100%",
    width: "100%",
    id: "canvasGrid"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gridpattern)",
    strokeWidth: 0,
    y: 0,
    x: 0,
    height: "100%",
    width: "100%"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#000",
    ry: 143.5,
    rx: 539.00001,
    id: "svg_3",
    cy: 173.74599,
    cx: 834.49995,
    strokeWidth: 1.5,
    fill: "#457821"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#000",
    ry: 143.5,
    rx: 539.00001,
    id: "svg_2",
    cy: 218.74599,
    cx: 237.49995,
    strokeWidth: 1.5,
    fill: "#5aa12d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#000",
    ry: 143.5,
    rx: 539.00001,
    id: "svg_1",
    cy: 251.74599,
    cx: 582.49995,
    strokeWidth: 1.5,
    fill: "#70c741"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayfooter);
export default __webpack_public_path__ + "static/media/dayfooter.a7b748c047b76fae0b877c6e87cce53e.svg";
export { ForwardRef as ReactComponent };